import { Box, Grid } from "@mui/material";
import React, { memo } from "react";
import SurveyCreateForm from "./SurveyCreateForm";
import "./styles/Survey.css";
import FleetCreationForm from "./FleetCreationForm";
import { ALIGN_ITEMS } from "../../utils/GlobalConstants";
import StoreCreationForm from "./StoreCreationForm";

const SurveyDialogView = () => {
  return (
    <React.Fragment>
      {/* survey section - start */}
      <Grid container>
        <Box component="fieldset" className="legend-lg-style fieldset-style">
          <legend className="legend-style">Surveys</legend>
          <SurveyCreateForm />
        </Box>
      </Grid>
      {/* survey section - end */}

      {/* fleet and jobber section - start */}
      <Grid container sx={ALIGN_ITEMS}>
        <Grid item md={5.9} lg={5.9} xs={12} sm={6}>
          <Box component="fieldset" className="fieldset-style">
            <legend className="legend-style">Fleets</legend>
            <Grid container sx={ALIGN_ITEMS}>
              <Grid item md={12} sm={12} xs={12} lg={12}>
                <FleetCreationForm />
              </Grid>
            </Grid>
          </Box>
        </Grid>

        <Grid item md={0.2} lg={0.2} />

        <Grid item md={5.9} lg={5.9} xs={12} sm={6}>
          <Box component="fieldset" className="fieldset-style">
            <legend className="legend-style">Stores</legend>
            <Grid container sx={ALIGN_ITEMS}>
              <Grid item md={12} sm={12} xs={12} lg={12}>
                <StoreCreationForm />
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
      {/* fleet and jobber section - end */}
    </React.Fragment>
  );
};

export default memo(SurveyDialogView);
